import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import clsx from 'clsx';
import styles from './image.module.scss';

export interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  fluid?: boolean;
  rounded?: boolean;
  className?: string;
  visibleByDefault?: boolean;
}

export const Image: React.FC<Props> = (props: Props) => {
  const { fluid, rounded, src, className, visibleByDefault = false, ...rest } = props;
  
  return (
    <LazyLoadImage className={
      clsx(
        styles['image'], 
        { 
          [styles['image--fluid']]: fluid, 
          [styles['image--rounded']]: rounded 
        },
        className
      )} 
      src={src}
      visibleByDefault={visibleByDefault}
      {...rest} 
    />
  );
};

export default React.memo(Image);
